// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__1ccN9","container":"Layout_container__3Sqlp","myVideo":"Layout_myVideo__3nGIA"};